import clsx from 'clsx';
import { FC } from 'react';
import { ListItem, ListItemProps } from '../list-item/list-item.tsx';
import classes from './numbered-list-item.module.scss';

export type NumberedListItemProps = ListItemProps;

export const NumberedListItem: FC<NumberedListItemProps> = ({ ...props }) => {
  return (
    <ListItem
      {...props}
      as="li"
      className={clsx(classes.root, props.className, 'numbered-list-item-component')}
      classes={{
        wrapper: classes.wrapper
      }}
      prefix={<div className={classes.prefixBackground} />}
    />
  );
};
